import router from "./router";
import i18n from "./i18n";
import store from "./store";

export const authModuleRouter = router;
export const authModuleI18n = i18n;
export const authModuleStore = store;
